import { render, staticRenderFns } from "./weizhibu.vue?vue&type=template&id=5e533228&scoped=true&"
import script from "./weizhibu.vue?vue&type=script&lang=js&"
export * from "./weizhibu.vue?vue&type=script&lang=js&"
import style0 from "./weizhibu.vue?vue&type=style&index=0&id=5e533228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e533228",
  null
  
)

export default component.exports